{
	"closes": "Closing: {{date}}",
	"columns": {
		"applications": "Applications sent",
		"call": "Call",
		"dsu_quota": "DSU quota",
		"flags": "Flags",
		"intake": "Direct applications",
		"offers": "Offers",
		"ranking": "Ranking",
		"reminder": "Reminder",
		"residence": "Residence"
	},
	"dsu_quota": {
		"below_threshold": "Below threshold",
		"figures": "{{seats}}/{{threshold}}",
		"no_threshold": "{{seats}}, missing data"
	},
	"empty": "No published call.",
	"empty_filtered": "No call matches the filters.",
	"filters": {
		"academic_year": "Academic year",
		"state": "Call state"
	},
	"flags": {
		"count_one": "{{count}} open",
		"count_other": "{{count}} open",
		"none": "None"
	},
	"intake": {
		"closed": "Closed",
		"declared": "By the manager, {{date}}",
		"expired": "At the deadline",
		"not_started": "Not open yet",
		"open": "Open"
	},
	"late": "Late",
	"never": "Never reminded",
	"offers": {
		"accepted_one": "{{count}} accepted",
		"accepted_other": "{{count}} accepted",
		"none": "Not started",
		"overdue_one": "{{count}} past the term of the manager",
		"overdue_other": "{{count}} past the term of the manager",
		"waiting_one": "{{count}} waiting",
		"waiting_other": "{{count}} waiting"
	},
	"other_year": "Current call only",
	"page_title": "Calls",
	"ranking_none": "Not calculated",
	"remind": {
		"command": "Remind",
		"confirm": "Send the reminder",
		"description": "We email every active manager of the residence the tasks waiting on their first page, with the deadlines. The reminder changes no outcome.",
		"nothing": "The residence has no task waiting: no reminder sent.",
		"sent_one": "Reminder sent to {{count}} manager",
		"sent_other": "Reminder sent to {{count}} managers",
		"title": "Remind the managers of {{residence}}?"
	},
	"reminded": "{{date}}",
	"reminded_by": "{{date}}, by {{name}}",
	"search_placeholder": "Search a residence",
	"until": "By {{date}}"
}
